var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 310,
    viewBox: "0 0 310 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8478 268.712L251.725 83.3837L252.1 83.009C252.177 82.9162 252.003 83.1055 252.088 83.0201C254.782 80.3266 261.047 81.4499 265.606 86.0085C270.165 90.5672 270.732 97.0183 268.038 99.7119L268.706 99.1256L86.4265 285.775",
    fill: "#984352"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8478 268.712L251.725 83.3837L252.1 83.009C252.177 82.9162 252.003 83.1055 252.088 83.0201C254.782 80.3266 261.047 81.4499 265.606 86.0085C270.165 90.5672 270.732 97.0183 268.038 99.7119L268.706 99.1256L86.4265 285.775",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.512 182.822C154.512 182.822 155.241 192.293 145.236 192.098Z",
    fill: "#D78E6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.512 182.822C154.512 182.822 155.241 192.293 145.236 192.098",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3753 241.442C97.3753 241.442 98.1154 256.919 82.9057 256.654Z",
    fill: "#D78E6D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3753 241.442C97.3753 241.442 98.1154 256.919 82.9057 256.654",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.333 166.312C171.333 166.312 171.881 175.861 161.872 175.669Z",
    fill: "#D78E6D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.333 166.312C171.333 166.312 171.881 175.861 161.872 175.669",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.22 151.683C185.22 151.683 186.035 161.499 176.03 161.304Z",
    fill: "#D78E6D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.22 151.683C185.22 151.683 186.035 161.499 176.03 161.304",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204.732 131.534C204.732 131.534 207.32 141.512 195.323 141.269Z",
    fill: "#D78E6D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M204.732 131.534C204.732 131.534 207.32 141.512 195.323 141.269",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M217.814 118.044C217.814 118.044 220.013 128.776 207.938 128.655Z",
    fill: "#D78E6D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M217.814 118.044C217.814 118.044 220.013 128.776 207.938 128.655",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M230.573 105.285C230.573 105.285 232.371 115.66 220.296 115.539Z",
    fill: "#D78E6D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M230.573 105.285C230.573 105.285 232.371 115.66 220.296 115.539",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M257.451 98.3776C260.145 95.6831 260.986 92.1553 259.329 90.498C257.671 88.8407 254.144 89.6815 251.449 92.376C248.755 95.0705 247.914 98.5984 249.571 100.256C251.228 101.913 254.756 101.072 257.451 98.3776Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M250.229 118.262C250.229 118.262 260.821 146.017 283.334 122.005C283.334 122.005 308.099 101.744 278.837 69.4839C278.837 69.4839 264.582 53.7305 239.07 58.2334C239.07 58.2334 169.631 69.7565 191.976 23.8575C191.976 23.8575 175.175 50.6954 194.743 59.3404C194.743 59.3404 216.199 66.8759 240.016 60.6779C240.016 60.6779 256.439 55.8571 271.014 65.2965C271.014 65.2965 308.096 94.2389 284.833 123.504C261.573 152.772 250.229 118.262 250.229 118.262Z",
    fill: "#879ECF",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M236.823 51.4821C236.823 51.4821 210.963 49.6341 216.766 37.4285C222.573 25.2266 236.823 51.4821 236.823 51.4821Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M185.05 55.2424C185.05 55.2424 155.325 49.5664 167.564 42.2754C179.803 34.9844 185.05 55.2424 185.05 55.2424Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M229.317 64.9899C229.317 64.9899 221.202 80.9537 215.129 76.3507C209.057 71.7477 229.317 64.9899 229.317 64.9899Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3634 285.971C89.0579 283.277 87.5472 277.397 82.9891 272.839C78.4311 268.281 72.5517 266.771 69.8572 269.465C67.1627 272.16 68.6734 278.039 73.2315 282.597C77.7895 287.155 83.6689 288.666 86.3634 285.971Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M250.229 118.262L253.227 115.205C252.424 99.7989 237.248 97.8605 237.248 97.8605L234.205 101.177C234.205 101.177 249.426 102.804 250.233 118.214",
    fill: "#37507C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M250.229 118.262L253.227 115.205C252.424 99.7989 237.248 97.8605 237.248 97.8605L234.205 101.177C234.205 101.177 249.426 102.804 250.233 118.214",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M105.338 224.288L128.95 200.676",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.307 215.495L117.46 206.343",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlute);
export default __webpack_public_path__ + "static/media/flute.168b644d1ed6452942c8ff5f34a23a5c.svg";
export { ForwardRef as ReactComponent };